import wrapper from 'wrapper';

class Methodology {
    constructor() {
        this.methodologyButton = wrapper.select('.methodology--button');
        this.methodologyContents = wrapper.select('.methodology__contents');
        this.methodologyButton.addEventListener('click', () => {
            if (this.methodologyContents.classList.contains('expanded')) {
                this.methodologyContents.classList.remove('expanded');
                this.methodologyButton.classList.remove('expanded');
                wrapper.trackUserAction('Methodology section closed', 'Methodology-toggle-collapse');
            }
            else {
                this.methodologyContents.classList.add('expanded');
                this.methodologyButton.classList.add('expanded');
                wrapper.trackUserAction('Methodology section expanded', 'Methodology-toggle-expand');
            }
        });
    }
}

export default Methodology;
